<template>
  <div class="create-role-page">
    <v-container>
      <v-row>
        <v-col cols="12" md="6">
          <v-card class="pa-6">
            <v-card-title>
              Создание новой роли
            </v-card-title>
            <v-form @submit.prevent="submitForm">
              <v-text-field
                v-model="form.title"
                label="Название роли *"
                required
              ></v-text-field>

              <v-select
                v-model="form.tag"
                :items="roleTags"
                label="Тег роли *"
                required
              ></v-select>

              <v-checkbox
                label="Можно создавать интервью"
                hide-details
              ></v-checkbox>

              <v-card-actions class="pt-4">
                <v-btn
                  color="primary"
                  type="submit"
                  :loading="loading"
                >
                  Создать роль
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import GlobalRequest from "../plugins/globalRequest";

export default {
  name: "RolePage",
  data() {
    return {
      roleCreateMethod: '/role/create',
      form: {
        title: '',
        tag: null
      },

      loading: false,
      createRoleId: null,
      roleTags: [
        {text: 'Обычная роль', value: 'ROLE_PLAIN'},
        {text: 'HR', value: 'ROLE_HR'},
        {text: 'Team Lead', value: 'ROLE_TEAM_LEAD'},
        {text: 'Администратор', value: 'ROLE_ADMIN'},
        {text: 'Пользователь', value: 'ROLE_USER'},
        {text: 'Интервьюер', value: 'ROLE_INTERVIEWER'},
      ]
    }
  },
  computed: {
    isValid(){
      return this.form.title && this.form.tag
    }
  },
  methods: {
    async submitForm() {
      if (!this.isValid) {
        return
      }

      // console.log(form)

      try {
        const response = await GlobalRequest.request(
          this.roleCreateMethod,
          'POST',
          this.form
        )

        if (response) {
          console.log(response)
          this.createRoleId = response.id
        }
      } catch (error) {
        console.log('Ошибка создания роли:'.error)
        //бубип
      } finally {
        this.loading = false
      }
    },
  }
}
</script>

<style scoped>

</style>
